// Единая логика расчёта цены курса.
//
// Зачем нужен этот хелпер
// ────────────────────────
// Раньше каждая карточка/деталка курса считала «есть ли скидка» по-своему:
//   • CourseCard брал ТОЛЬКО `discountPrice` — игнорил `discount %`
//   • CourseDetail сначала смотрел `discountPrice`, потом fallback на `discount`
//   • MyCourssesPage считал из `discount` напрямую
// → юзеры жаловались «на карточке цена не правильная»: бэк присылал discount=20%,
//   но discountPrice=null (старый курс) → карточка показывала полную цену.
//
// Источник истины — `discount %` (так инструктор управляет ценой в редакторе).
// Поле `discountPrice` оставляем в БД как ДЕНОРМАЛИЗАЦИЮ — оно нужно для
// быстрой сортировки/фильтрации в каталоге («sort by final price»), но
// для ОТОБРАЖЕНИЯ всегда вычисляем из percent.
//
// Все UI-компоненты должны использовать `computePricing(course)`.

const round = (n) => Math.round(Number(n) || 0);

/**
 * @param {{price?: number, discount?: number, discountPrice?: number}} course
 * @returns {{
 *   basePrice: number,      // оригинальная цена
 *   finalPrice: number,     // цена с учётом скидки
 *   discountPercent: number,// 0..100
 *   hasDiscount: boolean,   // true если скидка валидна и >0
 *   isFree: boolean,        // basePrice = 0
 * }}
 */
export function computePricing(course = {}) {
  const basePrice = Math.max(0, Number(course.price) || 0);
  const discountPercent = Math.max(0, Math.min(100, Number(course.discount) || 0));

  const isFree = basePrice === 0;
  const hasDiscount = discountPercent > 0 && basePrice > 0;
  const finalPrice = hasDiscount ? round(basePrice * (1 - discountPercent / 100)) : basePrice;

  return { basePrice, finalPrice, discountPercent, hasDiscount, isFree };
}

/**
 * Форматирование суммы в KZT с пробелами-разделителями.
 *   formatKzt(125000) → "125 000 ₸"
 *   formatKzt(0)      → "Бесплатно"
 */
export function formatKzt(amount, { free = 'Бесплатно' } = {}) {
  const n = Number(amount) || 0;
  if (n <= 0) return free;
  return `${n.toLocaleString('ru-RU')} ₸`;
}
